import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AppRouting } from '../enums';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { filter, map, take } from 'rxjs';

export const portingBlockGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(userFeature.selectIsPortingBlocked).pipe(
    filter((v) => v !== null),
    take(1),
    map((isPortingBlocked) => {
      const currentPath = route.routeConfig?.path;

      if (isPortingBlocked) {
        return currentPath === AppRouting.ContractTransfer
          ? true
          : new RedirectCommand(router.parseUrl(`/${AppRouting.ContractTransfer}`));
      } else {
        return currentPath === AppRouting.ContractTransfer
          ? new RedirectCommand(router.parseUrl(`/${AppRouting.Overview}`))
          : true;
      }
    })
  );
};
